import React from "react";
import AsyncSelect from "react-select/async";

// type OptionType = { value: number; label: string };

// interface ParentTaskSelectProps {
//     control: any;
//     name: string;
//     projectId: string | number;
// }

export default function ParentTaskSelect(props) {


    return (
        <div className="flex items-center">
            <AsyncSelect
                cacheOptions
                defaultOptions
                // loadOptions={loadOptions}
                placeholder="Chọn Parents Task..."
                className="flex-1 w-full  rounded-md shadow-sm focus:outline-none text-sm"
                {...props}
            />
        </div>
    );
}
